import React from 'react';
export function StatsBar() {
  const stats = [{
    value: '+200',
    label: 'FERTIGE STUNDEN'
  }, {
    value: '+5000',
    label: 'ZUFRIEDENE SCHÜLERINNEN'
  }, {
    value: '3.800+',
    label: 'GESPARTE STUNDEN'
  }, {
    value: '99%',
    label: 'WÜRDEN ES EMPFEHLEN'
  }];
  return <section className="border-y border-brand-creamDark bg-white/50 py-8" data-id="element-145">
      <div className="mx-auto max-w-5xl px-4" data-id="element-146">
        <div className="grid grid-cols-2 gap-y-8 text-center md:grid-cols-4 md:divide-x md:divide-brand-creamDark" data-id="element-147">
          {stats.map(stat => <div key={stat.label} className="flex flex-col items-center px-3" data-id="element-148">
              <span className="mb-1 font-serif text-3xl font-bold text-brand-text md:text-4xl" data-id="element-149">
                {stat.value}
              </span>
              <span className="text-[10px] font-semibold tracking-[0.12em] text-brand-gray md:text-xs" data-id="element-150">
                {stat.label}
              </span>
            </div>)}
        </div>
      </div>
    </section>;
}